export default __webpack_public_path__ + "static/media/1-3-x.d945952e.png";